/**
 * The phone tab bar's tabs: the four places a visitor goes most, and a Menu tab
 * that opens the full drawer for everything else. Pure, so
 * tests/tab-bar.test.mjs can check what each kind of visitor is offered.
 *
 * `icon` names a drawing in icons.js.
 *
 * Members get Home, Feed, Circles and Inbox: the social places. Learn (the
 * Fungarium, courses) and the Realm are in the drawer, which the Menu tab opens.
 */
import { APPROVED_MEMBER_ROLES } from '../../auth/member-roles.js';

const MENU = { id: 'menu', label: 'Menu', icon: 'menu', menu: true };

/**
 * @param {{user?: object|null, canEnterRealm?: boolean}} opts
 * @returns {Array<{id, label, icon, href?, match?: string[], badge?: boolean, menu?: boolean}>}
 */
export function tabsFor({ user = null, canEnterRealm = false } = {}) {
  const role = user?.publicMetadata?.role || null;
  if (user && APPROVED_MEMBER_ROLES.includes(role)) {
    return [
      { id: 'home', label: 'Home', icon: 'home', href: '/member/dashboard', match: ['/member/dashboard', '/member/threshold'] },
      { id: 'feed', label: 'Feed', icon: 'feed', href: '/member/feed' },
      { id: 'circles', label: 'Circles', icon: 'circles', href: '/member/circles' },
      { id: 'inbox', label: 'Inbox', icon: 'inbox', href: '/member/inbox', badge: true },
      MENU,
    ];
  }
  // Visitors, and anyone signed in whose membership is not approved yet.
  return [
    { id: 'home', label: 'Home', icon: 'temple', href: '/', match: ['/', '/pages/index.html'] },
    { id: 'events', label: 'Events', icon: 'events', href: '/events' },
    { id: 'join', label: 'Join', icon: 'join', href: '/become-a-member' },
    user
      ? { id: 'dashboard', label: 'Account', icon: 'account', href: '/member/dashboard' }
      : { id: 'signin', label: 'Sign in', icon: 'signin', href: '/member/login' },
    MENU,
  ];
}

/** Which tab is the page the visitor is on, or null. Home matches only itself. */
export function activeTabId(tabs, pathname) {
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  for (const t of tabs) {
    if (t.menu) continue;
    const roots = t.match || [t.href];
    if (roots.some((r) => (r === '/' ? path === '/' || path === '/pages/index.html' : path === r || path.startsWith(`${r}/`)))) return t.id;
  }
  return null;
}
